import { Button, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./HomePage.css";
import { s3_url } from "common/constants";

function HomePage() {
  return (
    <div>
      <h1>Lumen@home</h1>
      <hr />

      <p className="lead mb-5">
        Lumen@home nudi sveobuhvatne pripreme za maturu koje pomažu učenicima da
        se temeljito pripreme za ispite i postignu najbolje rezultate. Također,
        pružamo individualne poduke iz raznih školskih predmeta, prilagođene
        potrebama svakog učenika, kako bi se osigurao njihov uspjeh u školi.
      </p>

      <Container>
        <Row className="justify-content-around">
          <Col
            xs={6}
            lg={4}
            className="d-flex flex-column justify-content-center"
          >
            <Link
              to="/pripreme-za-maturu"
              className="d-flex flex-column justify-content-around align-items-center mb-4"
              style={{ height: "100%" }}
            >
              <img
                src={`${s3_url}/img/lumenko/Maturant.png`}
                alt="lumen maturant"
                className="hover-img"
                style={{
                  marginBottom: "1rem",
                  maxWidth: "100%",
                  height: "auto",
                }}
              />
              <Button variant="primary" size="lg">
                Pripreme za maturu
              </Button>
            </Link>
          </Col>
          <Col
            xs={6}
            lg={4}
            className="d-flex flex-column justify-content-center"
          >
            <Link
              to="/poduke"
              className="d-flex flex-column justify-content-around align-items-center"
              style={{ height: "100%" }}
            >
              <img
                src={`${s3_url}/img/lumenko/Lumenko_za_laptopom.png`}
                alt="lumenko laptop"
                className="hover-img"
                style={{
                  marginBottom: "1rem",
                  maxWidth: "100%",
                  height: "auto",
                }}
              />
              <Button variant="primary" size="lg">
                Individualne poduke
              </Button>
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default HomePage;
